import { attr } from '@ember-data/model';
import EmberDataBaseFragment from '@square/dashboard-data/models/ember-data-base-fragment';
import moment from 'moment';
import { inject as service } from '@ember/service';
function toMoment(timeOfDay) {
  return moment(`${timeOfDay.hour} ${timeOfDay.minute} 2013`, 'HH mm YYYY');
}
export default EmberDataBaseFragment.extend({
  store: service(),
  startLocalTime: attr('time-of-day'),
  endLocalTime: attr('time-of-day'),
  isNotDefined() {
    return !(this.startLocalTime && this.endLocalTime);
  },
  getLocalStartTimeMinutes() {
    return this.startLocalTime.hour * 60 + this.startLocalTime.minute;
  },
  getLocalEndTimeMinutes() {
    return this.endLocalTime.hour * 60 + this.endLocalTime.minute;
  },
  endIsBeforeOrEqualToStart() {
    const localEndTimeMinutes = this.getLocalEndTimeMinutes() === 0 ? 1440 // 24 (midnight) * 60
    : this.getLocalEndTimeMinutes();
    return this.getLocalStartTimeMinutes() >= localEndTimeMinutes;
  },
  endTimeIsNextDay() {
    const startTime = new Date().setHours(this.startLocalTime.hour, this.startLocalTime.minute);
    const endTime = new Date().setHours(this.endLocalTime.hour, this.endLocalTime.minute);
    return endTime < startTime;
  },
  doesOverlapWith(otherTimePeriod) {
    const thisStart = this.getLocalStartTimeMinutes();
    const otherStart = otherTimePeriod.getLocalStartTimeMinutes();
    const thisEnd = this.getLocalEndTimeMinutes();
    const otherEnd = otherTimePeriod.getLocalEndTimeMinutes();
    return otherStart >= thisStart && thisStart >= thisEnd || otherStart <= thisEnd && otherEnd >= thisEnd || otherStart <= thisStart && otherEnd >= thisStart || otherStart <= thisEnd && otherStart >= thisStart || thisStart <= otherEnd && thisEnd >= otherEnd;
  },
  toMoments() {
    return {
      startMoment: toMoment(this.startLocalTime),
      endMoment: toMoment(this.endLocalTime)
    };
  }
}).reopenClass({
  createFromStartTimeAndEndTime(store, startLocalTime, endLocalTime) {
    return store.createFragment('special-hours-time-period', {
      startLocalTime,
      endLocalTime
    });
  },
  _modelNameForMigration: 'special-hours-time-period'
});